import { FLYOUT_PARAM_NAMES } from './flyoutParams';

type UrlParts = { pathname: string; search: string };

const getSearchWithoutFlyoutParams = (search: string) => {
  const params = new URLSearchParams(search);
  FLYOUT_PARAM_NAMES.forEach((name) => params.delete(name));
  params.sort();
  return params.toString();
};

const hasFlyoutParam = (search: string) => {
  const params = new URLSearchParams(search);
  return FLYOUT_PARAM_NAMES.some((name) => params.has(name));
};

// Opening or closing a flyout that has its own URL, which is not a new page.
export const isSamePageFlyoutNavigation = (previous: UrlParts | null | undefined, next: UrlParts): boolean =>
  !!previous &&
  previous.pathname === next.pathname &&
  previous.search !== next.search &&
  getSearchWithoutFlyoutParams(previous.search) === getSearchWithoutFlyoutParams(next.search);

export const isSamePageFlyoutClose = (previous: UrlParts | null | undefined, next: UrlParts): boolean =>
  isSamePageFlyoutNavigation(previous, next) && !hasFlyoutParam(next.search);
